/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  isLoading: false,
  error: undefined,
  isChatSessionComplete: false,
  messages: [],
  accuracyOfLastAttempt: 0,
  lastGuessNumber: 0
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.YAK_CHAT_RESET:
      return initialState;
    case types.YAK_CHAT_LOADING:
      return state.merge({ isLoading: true });
    case types.YAK_CHAT_ADD_USER:
      const lastGuessNumber = state.get('lastGuessNumber');
      const thisGuessNumber = lastGuessNumber + 1;
      return state.merge({ lastGuessNumber: thisGuessNumber }).update('messages', list => list.push(Immutable.fromJS({
        userMessage: action.userMessage,
        guessesSoFar: thisGuessNumber
      })))
    case types.YAK_CHAT_ADD_AI:
      return state.update('messages', list => list.push(Immutable.fromJS({
        aiResponseMessage: action.aiResponseMessage,
        guessesRemaining: 3,
        guessesSoFar: 0
      })))
    case types.YAK_CHAT_SUCCESS:
      return state.merge({
        isLoading: false,
        error: undefined,
        isChatSessionComplete: action.isChatSessionComplete,
        accuracyOfLastAttempt: action.accuracy,
        lastGuessNumber: action.guessesSoFar
      }).update('messages', list => list.push(Immutable.fromJS({
        aiResponseMessage: action.aiResponseMessage,
        accuracy: action.accuracy,
        guessesRemaining: action.guessesRemaining,
        guessesSoFar: action.guessesSoFar
      })));
    case types.YAK_CHAT_ERROR:
      return state.merge({ isLoading: false, error: action.error });
    default:
      return state;
  }
}; 


// WEBPACK FOOTER //
// ./src/stores/tack_ai_chat/reducer.js